<template>
  <p-container class="page automation test" fill-height>
    <h2>Automation Widget Test: Reactivation</h2>
    <p-fieldset class="configuration" label="Konfiguration">
      <p-row>
        <p-col xs12 md3>
          <p-text-field v-model="contactId" label="KontaktId (Guid)"></p-text-field>
        </p-col>
        <p-col xs12 md3>
          <p-select v-model="tenantKey" label="Mandant" :items="tenantList"></p-select>
        </p-col>
        <p-col xs12 md3>
          <p-select v-model="languageIso2" label="Sprache" :items="languages"></p-select>
        </p-col>
        <p-col xs12 md3>
        </p-col>
      </p-row>
      <p-row>
        <p-col xs12 md3>
          <p-text-field v-model="submitRedirectUrl" label="Senden Redirect Url"></p-text-field>
        </p-col>
        <p-col xs12 md3>
          <p-text-field v-model="submitAndDonateRedirectUrl" label="Senden & Spenden Redirect Url"></p-text-field>
        </p-col>
        <p-col xs12 md3>
        </p-col>
        <p-col xs12 md3 class="pt-7">
          <p-button @click="onUpdateClick()">
            Laden
          </p-button>
        </p-col>
      </p-row>
    </p-fieldset>
    <p-fieldset class="widget" label="Widget">
      <div id="widgetContainer"></div>
    </p-fieldset>
    <!-- Embed Code: //https://gaute.dev/dev-blog/script-in-vue -->
    <script
      type="application/javascript"
      async="async"
      data-router-mode="abstract"
      data-mount-id="widgetContainer"
      data-route="widgets/automation/reactivation"
      data-language="de"
      src="/js/app.js"
    >
    </script>
  </p-container>
</template>

<script>

  export default {
    auth: true,
    role: ['Admin', 'Hostadmin'],
    data: () => ({
      contactId: '',
      languageIso2: 'de',
      submitRedirectUrl: '',
      submitAndDonateRedirectUrl: '',
      tenantKey: 'kls',
      tenantList: [
        { caption: 'KLS', id: 'kls' },
        { caption: 'KFS', id: 'kfs' },
      ],
      languages: [
        { caption: 'Deutsch', id: 'de' },
        { caption: 'Französisch', id: 'fr' },
        { caption: 'Italienisch', id: 'it' },
        { caption: 'Englisch', id: 'en' },
      ],
    }),
    computed: {
    },
    mounted() {
      const queries = this.$routerUtils.getQueryParams();
      if (queries.contactid) this.contactId = queries.contactid;
      if (queries.tenantKey) this.tenantKey = queries.tenantKey;
      if (queries.language) this.languageIso2 = queries.language;
      if (queries.submitRedirectUrl) this.submitRedirectUrl = queries.submitRedirectUrl;
      if (queries.submitAndDonateRedirectUrl) this.submitAndDonateRedirectUrl = queries.submitAndDonateRedirectUrl;
    },
    methods: {
      onUpdateClick() {
        this.$router.push(`/_admin/widgets/contactAutomationReactivation?contactid=${this.contactId}&tenantKey=${this.tenantKey}&language=${this.languageIso2}&submitRedirectUrl=${this.submitRedirectUrl}&submitAndDonateRedirectUrl=${this.submitAndDonateRedirectUrl}`);
      },
    },
  };
</script>
